module.exports = __webpack_public_path__ + "img/stage-prepare-offer.756a6e67.png";